import moment from 'moment'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import LaunchTooltip from '../LaunchTooltip'
import styles from '../MontlyRevenue.module.scss'
import RevenueTooltip from '../RevenueTooltip'
import Summary from '../Summary'
import { barSize } from '../utils/constants'
import { thousandAndMillionFormatter } from '../utils/formatters'

const SingleChart = ({
  label,
  firstYear,
  secondYear,
  firstYearTotal,
  secondYearTotal,
  deltaPercentage,
  deltaFlat,
  syncId,
  data,
  firstYearColor,
  secondYearColor,
  serviceStartDate,
  valueFormatter = value => value,
  isHighDeltaGood = true
}) => {
  return (
    <div className={styles.chartBox}>
      <Summary
        firstYear={firstYear}
        secondYear={secondYear}
        firstYearColor={firstYearColor}
        secondYearColor={secondYearColor}
        label={label}
        firstYearValue={firstYearTotal}
        secondYearValue={secondYearTotal}
        deltaPercentage={deltaPercentage}
        deltaFlat={deltaFlat}
        isHighDeltaGood={isHighDeltaGood}
      />
      <div className={styles.chartBoxInner}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            syncId={syncId}
            margin={{
              top: 0,
              right: 40,
              left: 20,
              bottom: 15
            }}
          >
            <CartesianGrid stroke="#F2F2F2" vertical={false} />
            <XAxis
              dataKey="month"
              axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
              tick={{
                fill: '#7D7D7D',
                fontSize: 12,
                transform: 'translate(0, 14)'
              }}
              tickSize={0}
              padding={{ left: 40, right: 40 }}
            />
            <YAxis
              tickSize={0}
              axisLine={false}
              allowDecimals={false}
              tick={{
                fill: '#7D7D7D',
                fontSize: 12
              }}
              padding={{ top: 35, bottom: 0 }}
              tickFormatter={thousandAndMillionFormatter}
              range
            />
            <Tooltip
              content={
                <RevenueTooltip
                  labelFormatter={date => date}
                  dataTitle={label}
                  firstYear={firstYear}
                  secondYear={secondYear}
                  valueFormatter={valueFormatter}
                />
              }
              cursor={{
                stroke: 'red',
                strokeWidth: 0,
                fill: '#dedede',
                opacity: 0.22
              }}
            />
            {[secondYear.toString()].includes(
              moment(serviceStartDate).format('YYYY')
            ) && (
              <ReferenceLine
                x={moment(serviceStartDate).format('MMM')}
                style={{
                  transform: `translateX(${'7px'})`
                }}
                strokeDasharray="3 3"
                isFront={false}
                label={props => (
                  <LaunchTooltip
                    {...props}
                    serviceStartDate={serviceStartDate}
                    style={{
                      transform: `translateX('7px'})`
                    }}
                    isFirstYear={
                      firstYear.toString() === moment(serviceStartDate).format('YYYY')
                    }
                  />
                )}
                stroke="#2158CF"
              />
            )}
            <Bar dataKey="firstYear" fill={firstYearColor} barSize={barSize} />
            <Bar dataKey="secondYear" fill={secondYearColor} barSize={barSize} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default SingleChart
